<template>
    <div>
        <input type="text" :value="value" @input="input" class="form-control" :class="{'is-invalid': isInvalid()}">
        <div class="invalid-feedback d-block" v-if="isInvalid()">
          {{ $t('form.errors.parameterNotFilled', [label])}}
        </div>
    </div>
</template>

<script lang="ts">
import {Control} from '@/composables/Control';
import {defineComponent, PropType, ref, watch} from 'vue';

export default defineComponent({
    props: {
        value: {
            type: String as PropType<string | null>,
            default: null,
        },
        validate: {
            type: Boolean,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
    },
    emits: ['input', 'validated'],
    setup(props, {emit}) {
        const filledValue = ref('');

        const {updateValue, isInvalid} = Control<string>(props, emit, {
            getValue: () => filledValue.value === '' ? null : filledValue.value,
        });

        watch(filledValue, () => {
            updateValue();
        });

        // created logic
        if (props.value !== null) {
            filledValue.value = props.value;
        }

        function input(event: any): void {
            filledValue.value = event.target.value;
        }

        return {
            filledValue,
            input,
            isInvalid,
        };
    },
});
</script>
